import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { useAssignReviewerToConsignment, useCurrentConsignment } from '../api'

export function useAssignReviewer() {
  const queryClient = useQueryClient()
  const {
    data: { consignment },
  } = useCurrentConsignment()

  const { mutateAsync: assignReviewer, isPending } = useAssignReviewerToConsignment()

  // Assign reviewer to consignment if not assigned
  useEffect(() => {
    const assignReviewerIfNeeded = async () => {
      if (!consignment.reviewer) {
        await assignReviewer({
          path: {
            key: consignment.key,
          },
        })
        queryClient.invalidateQueries(
          apiClient.getConsignmentConsignmentsKeyGetOptions({
            path: {
              key: consignment.key,
            },
          }),
        )
      }
    }
    assignReviewerIfNeeded()
  }, [assignReviewer, consignment.key, consignment.reviewer, queryClient])

  return {
    assigningInProgress: isPending,
  }
}
